import React from 'react';
import { Select } from 'antd';
import {
  RETRIEVER_SEARCH_TYPE_OPTIONS,
  retrieverSearchTypeLabel,
} from '../constants/retrieverSearchTypes';

const selectOptions = RETRIEVER_SEARCH_TYPE_OPTIONS.map((o) => ({
  value: o.value,
  label: o.label,
  title: o.title,
  subtitle: o.subtitle,
}));

/**
 * Search Type select: guided subtitles in the dropdown, friendly label when closed.
 * Uses Ant Design `options` + `optionRender` (reliable in v5; `optionLabelProp` often shows raw value).
 */
export default function RetrieverSearchTypeSelect({ hintStyle, titleStyle, ...selectProps }) {
  return (
    <Select
      {...selectProps}
      options={selectOptions}
      optionRender={(option) => (
        <div>
          <div style={{ fontWeight: 500, ...titleStyle }}>{option.data?.title ?? option.label}</div>
          <div style={hintStyle}>{option.data?.subtitle}</div>
        </div>
      )}
      labelRender={({ value, label }) => (
        <span>{label ?? retrieverSearchTypeLabel(value)}</span>
      )}
    />
  );
}
